import React, {Component} from 'react';
import SVGInline from 'react-svg-inline';
import renderHTML from 'react-render-html';
import { bindActionCreators, compose } from "redux"
import { withProps, withStateHandlers } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps"
import {connect} from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import Article from './main/article';
import Empty from './main/empty';
import NavBar from '../containers/parts/NavBar';

class MapKioskStatic extends Component {
	
	constructor(props) {
	    super(props)
	    this.state = {
	      markers: this.props.markers,
	      path: this.props.path,
	      title: this.props.title
	    }
	}
	
	componentWillUpdate() {
		window.scrollTo(0, 0);
		
	}	
	
	isSingle() {
		return 1 === this.state.markers.length;
	}
	
	renderMarkers(posts) {
		var index = 1;
		//console.log("these are the posts markers data!");
		//console.log(posts);
		if (posts.length) {
			return posts.map( post => {
				if (post) {
					//console.log("these are the individual post marker data!");
					//console.log(post);
					let thisID = post.id;
					let latVal = parseFloat(post.lat);
					let lngVal = parseFloat(post.lng);
					var icon = "/wp-content/themes/chester-county-kiosk/images/covered-bridge.svg";
					if ('icon' in post){
						icon = "/wp-content/themes/chester-county-kiosk/images/" + post.icon;	
					}
					
					const coords = {id: thisID, coords: { lat: latVal, lng: lngVal }, header: post.title, content: post.description, image: "/wp-content/themes/chester-county-kiosk/images/"+this.state.path+"/" + post.image, icon: icon };
					//console.log("transformed marker data");
					//console.log(coords);
					index++;
					return (coords);
				} else {
					return null;
				}
			});
		} else {
			const counter = [...Array(1)];
			return counter.map((val, i) => {
				let thisID = i;
				let latVal = parseFloat(39.950177 + (i / 100));
				let lngVal = parseFloat(-75.590137 + (i / 100));
				const coords = {id: thisID, coords: { lat: latVal, lng: lngVal }}; 
				//console.log(markerPos);
				return (coords);
			});
		}
		
	}

	
	render() {
		const marketState = withStateHandlers({
			isOpen: false
		}, {
			onMarkerClick: ({isOpen}) => () => ({isOpen: !isOpen})
		})
		
	        // This is the key!
		const MarkerPoint = compose(marketState)(props =>
			<Marker 
				key={props.marker.id}
			    position={{lat: props.marker.coords.lat, lng: props.marker.coords.lng}}
			    onClick={() => props.onMarkerClick()}
			    icon={{url: props.marker.icon, scaledSize: { width: 46, height: 46 }}} >
	
				{props.isOpen &&
				   	<InfoWindow 
				   		position={{lat: props.marker.coords.lat, lng: props.marker.coords.lng}}
				        onCloseClick={() => props.onMarkerClick()}>
					    <div>
					    	<img src={props.marker.image} className="alignright pop-image" />
					    	<div id="content"><h1>{ renderHTML( props.marker.header ) }</h1></div>
					    	{ renderHTML( props.marker.content ) }
					    </div>
				    </InfoWindow>
				}
			</Marker>
		)
	
		const MapWithMarkers = compose(withScriptjs, withGoogleMap)(props =>
			<GoogleMap key={Math.floor(Math.random() * 100)}
			        defaultZoom={11}
					defaultCenter={{lat: 39.936910, lng: -75.658260}}>
				{
					props.markers.map((marker) => {
						if (marker.coords.lat && marker.coords.lng){
							return (<MarkerPoint marker={marker}/>)
						} else {
							return null;
						}
					})
				}
			</GoogleMap>
		)
		console.log('props!!');
		console.log(this.state.markers);
		return (
			<div className="kiosk-wrapper">
				<div className="map-wrapper">
					<MapWithMarkers
					    markers={this.renderMarkers(this.state.markers)}
					    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDlm1GMaQ12XiEttSQP7ay5AO9Y_um4LaQ&v=3.exp&libraries=geometry,drawing,places"
					    loadingElement={<div style={{ height: `100%` }}/>}
					    containerElement={<div id="map"/>}
					    mapElement={<div style={{ height: `100%`}} />}
					    />
				</div>
			</div>
		);
	}
}


function mapStateToProps({posts}) {
	return {posts};
}

export default connect(mapStateToProps)(MapKioskStatic)



// WEBPACK FOOTER //
// ./src/components/map-kiosk-static.js